import styled from 'styled-components';
export const InputErrorIcon = styled.div `
  width: 20px;
  height: 20px;
  background-color: ${props => props.theme.colors.error};
  border-radius: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='12'%3E%3Cpath fill='%23fff' d='M1.99 12c.82 0 1.509-.656 1.509-1.418 0-.78-.69-1.436-1.51-1.436-.82 0-1.49.656-1.49 1.436 0 .762.67 1.418 1.49 1.418zm1.043-4.024L3.406 0H.555l.391 7.976z'/%3E%3C/svg%3E");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: 4px 12px;
  position: relative;

  > * {
    opacity: 0;
    pointer-events: none;
    transition: opacity .3s ease;
  }

  &:hover > * {
    opacity: 1;
    pointer-events: all;
  }
`;
export const InputErrorIconTooltip = styled.div `
  background: #fff;
  position: absolute;
  right: 30px;
  bottom: -50%;
  margin-bottom: 0px;
  user-select: none;
  font-size: 13px;
  color: ${props => props.theme.colors.error};
  white-space: nowrap;
  z-index: 120;
  width: max-content;
  padding: 10px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

  @media (min-width: 1280px) {
    left: 50%;
    bottom: 50%;
    transform: translateX(-50%);
    margin-bottom: 23px;
  }

  .shadow {
    position: absolute;
    bottom: 16px;
    width: 16px;
    height: 16px;
    right: -8px;

    @media (min-width: 1280px) {
      bottom: -30px;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: 23px;
      right: 50%;
    }

    &::after {
      position: absolute;
      content: ' ';
      width: 16px;
      height: 16px;
      background: #fff;
      transform: rotate(45deg);
      box-shadow: 3px 3px 6px -8px rgba(0, 0, 0, 0.16);

      @media (min-width: 1280px) {
       box-shadow: 3px 3px 6px 0 rgba(0, 0, 0, 0.16);
      }
    }
  }

  span {
    font-weight: 700;
    display: inline-block;
    word-wrap: pre-wrap;
    width: 100%;
    white-space: normal;  
    max-width:200px;  
    word-wrap: break-word;

    @media (min-width: 768px) {
       max-width:300px;
      }
  }
`;
